/* istanbul ignore file */
import React from 'react';

import { ApolloProvider } from '@apollo/client';
import { LocationProvider } from '@reach/router';
import { StoreProvider } from 'easy-peasy';
import ReactDOM from 'react-dom';
import { HeadProvider } from 'react-head';

import { store, history } from '@client/common/store';

import { apolloClient } from './apollo-client';
import MaintenancePage from './common/components/MaintenancePage';
import App from './common/containers/App';
import { loadHeapScript } from './common/containers/EventTracking/utils/loadHeapScript';
import { initializeDatadog } from './datadogRum';
import { ExperimentProvider } from './experiments/ExperimentProvider';
import { preventBrowsing, sessionExpired } from './utils/authentication';

// Handle Session expiration
document.removeEventListener('click', preventBrowsing);
document.addEventListener('session-expired', sessionExpired);

async function main () {
  initializeDatadog();
  loadHeapScript();

  if (process.env.DOWN_FOR_MAINTENANCE === 'true') {
    ReactDOM.render(
      <MaintenancePage />,
      document.getElementById('app')
    );
  } else {
    ReactDOM.render(
      <StoreProvider store={store}>
        <LocationProvider history={history}>
          <ApolloProvider client={apolloClient}>
            <HeadProvider>
              <ExperimentProvider>
                <App />
              </ExperimentProvider>
            </HeadProvider>
          </ApolloProvider>
        </LocationProvider>
      </StoreProvider>,
      document.getElementById('app')
    );
    // Enable hot module replacement when developing
    // note: webpack removes this in production
    module.hot.accept();
  }
}

main();
